<template>
  <div class="main-content">

    <!-- Section: inner-header -->
    <section class="inner-header divider parallax layer-overlay overlay-dark-5 pt-100" data-parallax-ratio="0.7" data-bg-img="images/202208/Sarah39.jpg">
      <div class="container pt-100 pb-50">
        <!-- Section Content -->
        <div class="section-content pt-100">
          <div class="row">
            <div class="col-md-12">
              <h3 class="title text-white">About Me</h3>
            </div>
          </div>
        </div>
      </div>
    </section>
    
    <!-- Section: About -->
    <section id="about">
      <div class="container pt-70">
        <div class="section-content">
          <div class="row pb-40">
            <!-- <div class="col-md-1">
              <i class="flaticon-boxing-gym-2 font-72 line-height-1"></i>
            </div> -->
            <div class="col-md-7">
              <h2 class="title text-uppercase mt-0 letter-space-3 font-40 line-bottom">2008</h2>
              <p>Inizio a praticare jiu-jitsu brasiliano all'età di 15 anni, e lo pratico fino ai 23, quando sarò costretta ad abbandonare la mia carriera da agonista a causa di un brutto infortunio al ginocchio, procurato vincendo l'europeo Naga in Francia.</p>
            </div>
            <div class="col-md-5">
              <img src="images/_aboutme/FOTO1.jpg" alt="" />
            </div>
          </div>

          <div class="row pb-40">
            <div class="col-md-7 col-md-push-5">
              <h2 class="title text-uppercase mt-0 letter-space-3 font-40 line-bottom">2015</h2>
              <p>Lo sport è la costante comune a tutta la mia vita: determinata ed ambiziosa, da sempre, è porto sicuro per dimostrare il mio valore. Inizio, in questo modo, ad avvicinarmi con passione al CrossFit e al sollevamento pesi, a cui già, in realtà, mi approcciavo in precedenza, ma nella sola preparazione atletica, praticandolo e perfezionandone la conoscenza, sino a farne la mia professione.</p>
            </div>
            <div class="col-md-5 col-md-pull-7">
              <img src="images/_aboutme/FOTO2.jpg" alt="" />
            </div>
          </div>

          <div class="row pb-40">
            <div class="col-md-7">
              <h2 class="title text-uppercase mt-0 letter-space-3 font-40 line-bottom">2019</h2>
              <p>Divento istruttrice personal trainer FIPE, atleta di sollevamento pesi, insegnante di  Crossfit  e di  ginnastica, cintura marrone ed ex-atleta di livello nazionale ed internazionale di jiu-jitsu brasiliano. Non basta allenare la forza: bisogna allenare anche l'agilità, la coordinazione, l'equilibrio, la precisione. Il fisico atletico, ma flessibile e femminile, che con costanza ho ricercato ed ottenuto, rispecchia la ricerca di equilibrio e completezza, sia interiore che sportiva, che è sempre stato il mio obiettivo.</p>
            </div>
            <div class="col-md-5">
              <img src="images/_aboutme/FOTO3.jpg" alt="" />
            </div>
          </div>

          <div class="row pb-40">
            <div class="col-md-7 col-md-push-5">
              <h2 class="title text-uppercase mt-0 letter-space-3 font-40 line-bottom">20-07-2020</h2>
              <p>Il mio programma di allenamento, Movement Flow,  nasce per raggiungere quante più persone possibili, che sposano la mia stessa idea di sport e di benessere.</p>
            </div>
            <div class="col-md-5 col-md-pull-7">
              <img src="images/_aboutme/FOTO4.jpg" alt="" />
            </div>
          </div>
          <div class="row pb-40">
            <div class="col-md-7">
              <h2 class="title text-uppercase mt-0 letter-space-3 font-40 line-bottom"><span class="text-theme-colored">2022</span></h2>
              <p>Movement Flow cresce sempre di più e segue il flusso del cambiamento. <BR/><BR/>
                Io continuo il mio percorso di studio e crescita personale acquisendo anche la certificazione come insegnante di Hata Yoga.
              </p>
            </div>
            <div class="col-md-5">
              <img src="images/Jan21/Sarah-042.jpg" alt="" />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<style scoped>
#about .title {
  display: inline-block;
}

section{
    background-position: 0 -200% !important;
    background-size: 100%;
}

#about .title.line-bottom {
  padding-bottom: 0;
  margin-bottom: 10px;
}
#about .title.line-bottom::after {
  height: 2px;
  width: 100%;
}
</style>

<script>
export default {
  name: "AboutMe",
};
</script>